const TARGET_SMILES_MAX_LENGTH = 65;

export function ellipsiseTargetSmiles(smiles?: string) {
  if (!smiles) {
    return 'none';
  }

  if (smiles.length > TARGET_SMILES_MAX_LENGTH) {
    const first = smiles.substring(0, Math.round(TARGET_SMILES_MAX_LENGTH / 2) - 2);
    const last = smiles.substring(smiles.length - Math.round(TARGET_SMILES_MAX_LENGTH / 2) + 1);
    return `${first} ... ${last}`;
  }

  return smiles;
}
